import { Button, Css, useModal } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { observer } from "mobx-react";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { BaseCostDimensionsModal } from "src/routes/bids/plan-based-bid-package/components/BaseCostDimensionsModal";
import { BidPlanDimensionRows } from "src/routes/bids/plan-based-bid-package/components/BidPlanDimensionRows";
import { groupKey, isBaseGroup, PlanBasedBidPackageFormState } from "src/routes/bids/plan-based-bid-package/utils";

type StandardBaseBidSectionProps = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
};

export const StandardBaseBidSection = observer(function StandardBaseBidSection(props: StandardBaseBidSectionProps) {
  const { formState, dimensionResults } = props;
  const { openModal } = useModal();
  const baseGroups = formState.bidPlanGroups.rows.filter((g) => isBaseGroup(g.value));
  const hasDimensions = baseGroups.some((g) => g.dimensions.rows.nonEmpty);

  return (
    <div css={Css.df.fdc.gap2.mb6.$}>
      <div css={Css.df.aic.jcsb.$}>
        <div css={Css.lg.$}>Base Bid Cost Dimensions</div>
        <Button
          icon="plus"
          label="Add Cost Dimension"
          variant="secondary"
          onClick={() =>
            openModal({
              content: <BaseCostDimensionsModal formState={formState} dimensionResults={dimensionResults} />,
            })
          }
        />
      </div>
      <div>
        Add cost dimensions that affect the base bid. If none are added, the base bid will have one cost line per
        product offering.
      </div>
      {!hasDimensions ? (
        <div css={Css.bgGray100.br8.py3.tac.gray700.$}>No cost dimensions added.</div>
      ) : (
        baseGroups.map((group) => (
          <div key={groupKey(group.value)} css={Css.bcGray200.pt1.$}>
            <BidPlanDimensionRows group={group} dimensionResults={dimensionResults} />
          </div>
        ))
      )}
    </div>
  );
});
